"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotHeart = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotHeart = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M18.683 9.72c-2.763.623-7.152 1.676-10.352 4.811-3.2 3.145-5.498 8.661-3.7 11.824 1.808 3.154 7.716 3.945 12.917 5.21 5.212 1.275 9.71 3.024 12.853 1.61 3.134-1.414 4.896-5.982 5.833-9.917.945-3.936 1.047-7.23.13-9.983-.91-2.753-2.857-4.958-5.073-5.684-2.226-.716-4.729.038-6.705.67-1.975.632-3.13.825-5.903 1.458Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M34.732 7.683a9.165 9.165 0 0 0-12.966 0L19.999 9.45l-1.767-1.767A9.169 9.169 0 1 0 5.266 20.65l1.766 1.767L20 35.383l12.967-12.966 1.766-1.767a9.165 9.165 0 0 0 0-12.967v0Z"
  }));
};
exports.SpotHeart = SpotHeart;
SpotHeart.displayName = "SpotHeart";